/**
 * Created by rathompson on 1/28/22
 * File: Addon
 * Project: MSP ©Palo Alto Networks
 * © Palo Alto Networks
 */

// import statement lib, local then scss or css

/**
 *   TODO: Brief what is this component/class do
 */
import { useEffect, useMemo } from 'react'
import { Checkbox, Select } from '@panwds/react-form-legacy'
import { Body } from '@panwds/react-ui'
import styled from 'styled-components'
import { useFormContext } from 'react-hook-form'
import SubNet from './SubNet'

const Details = styled.div`
  button {
    justify-content: space-between;
    color: #333333;
  }
`
/**
 * render addon
 * @param {object} addon
 * @param {boolean} useManifestDisplayName to use app defination display name rather than license display name
 *
 */
const Addon = (props) => {
  const {
    addon,
    loading,
    apps,
    selectedTSGInstances,
    domainPostFix,
    selectedTreeNode,
    displayCheckBox = true,
    useManifestDisplayName = false,
  } = props
  const { setValue, getValues } = useFormContext()

  const addonAppId = useMemo(() => addon?.app_id, [addon])
  const appManifest = useMemo(() => apps[addonAppId], [apps, addonAppId])
  const addonName = useMemo(() => `${addonAppId}_instance`, [addonAppId])
  const hasInstance = useMemo(() => Boolean(appManifest), [appManifest])
  const hasSubnet = useMemo(() => appManifest?.hasOwnProperty('customizable_subdomain'), [appManifest])
  const subnetName = useMemo(() => (hasSubnet ? `${addonAppId}_subnet` : undefined), [addonAppId, hasSubnet])
  const existedInstance = useMemo(() => selectedTSGInstances?.find(instance => instance?.app_id === addonAppId), [addonAppId, selectedTSGInstances])
  const addonDisplayName = useMemo(() => (useManifestDisplayName ? appManifest?.display_name : addon?.license_display_name), [addon, appManifest, useManifestDisplayName])
  const instDropdownItems = useMemo(() => {
    if (!existedInstance) {
      setValue(addonName, { value: 'Create New' }, { shouldDirty: true, shouldValidate: true })
      return [{ value: 'Create New' }]
    }
    setValue(addonName, { value: existedInstance.tenant_id, id: existedInstance.tenant_id })
    return [{ value: existedInstance.tenant_id }]
  }, [setValue, existedInstance, addonName])

  useEffect(() => {
    if (hasSubnet && existedInstance) {
      const url = existedInstance?.url?.split('.')[0]?.replace('http://', '').replace('https://', '')
      setValue(subnetName, url)
    }
    if (hasSubnet && !existedInstance) {
      setValue(subnetName, '')
    }
  }, [hasSubnet, addon, domainPostFix, setValue, existedInstance, instDropdownItems, subnetName])

  const cspAccount = getValues('support_account')?.id

  return (
    <div className="tw-flex tw-flex-1">
      <div className="tw-flex tw-flex-1">
        <div className="tw-flex tw-items-center tw-flex-1 tw-gap-2">
          {<Checkbox
            style={{ visibility: displayCheckBox ? 'visible' : 'hidden' }}
            label={addonDisplayName}
            name={addonAppId}
            showLabel={false}
            disabled
            defaultValue={true}
            register={{
              required: false,
              value: true
            }}
          />}
          <Body addClassName="tw-font-lato">{addonDisplayName}</Body>
        </div>
        {hasInstance && (
          <Details className="tw-flex tw-items-center tw-flex-1">
            <Select
              addClassName='cmm-modal-select'
              disabled={true}
              name={addonName}
              label={addonName}
              showLabel={false}
              defaultValue={instDropdownItems[0]}
              selectedItem={instDropdownItems[0]}
              items={instDropdownItems}
            />
          </Details>
        )}
      </div>
      <div className="tw-flex tw-items-center" style={{ flex: 2 }}>
        {hasSubnet && <SubNet {...{ subnetName, domainPostFix, cspAccount, existedInstance, entitlement: addon, selectedTreeNode, loading }} />}
      </div>
    </div>
  )
}

Addon.propTypes = {}
export default Addon
